import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import utils from '@utils';

class InvoiceInfo extends PureComponent {
	formatRecurrenceEndDate = (dateString) => {
		const endDate = new Date(dateString);
		return endDate.toLocaleString(undefined, {
			month : 'long',
			day   : 'numeric',
			year  : 'numeric',
		});
	}

	render() {
		const { invoiceEstimate, timeZoneId, getInvoiceEstimatePDF } = this.props;
		const addressParams = {
			address   : invoiceEstimate.LocationAddress.StreetAddress,
			city      : invoiceEstimate.LocationAddress.City,
			state     : invoiceEstimate.LocationAddress.StateName,
			zip       : invoiceEstimate.LocationAddress.Zip,
			latitude  : invoiceEstimate.LocationAddress.Latitude,
			longitude : invoiceEstimate.LocationAddress.Longitude,
		};

		const formattedAddress = utils.concatenateAddressDetails({ ...addressParams });

		return (
			<Fragment>
				<Row className="margin-bottom-15">
					<Col sm={3} className="text-right text-left-xs">Sent By:</Col>
					<Col sm={1} />
					<Col sm={8}>{ invoiceEstimate.AgencyContactName }</Col>
				</Row>
				<Row className="margin-bottom-15">
					<Col sm={3} className="text-right text-left-xs">Job Date/Time:</Col>
					<Col sm={1} />
					<Col sm={8}>
						<span>{ utils.parseUTCDateToTimeZone(invoiceEstimate.JobEventStartDateTime, timeZoneId).format('MMMM DD, YYYY') }</span>
						&nbsp;
						<span>{ utils.parseUTCDateToTimeZone(invoiceEstimate.JobEventStartDateTime, timeZoneId).format('h:mm A') }</span>
						<span> - </span>
						<span>{ utils.parseUTCDateToTimeZone(invoiceEstimate.JobEventEndDateTime, timeZoneId).format('h:mm A') }</span>
					</Col>
				</Row>
				<Choose>
					<When condition={invoiceEstimate.JobEventRecurrenceRepeatsOn}>
						<Row className="margin-bottom-15">
							<Col sm={3} className="text-right text-left-xs">Recurring:</Col>
							<Col sm={1} />
							<Col sm={8} className="text-capitalize">{invoiceEstimate.RecurrenceDescription.replace(/,/gi, ', ')}</Col>
						</Row>
					</When>
					<When condition={invoiceEstimate.JobEventRecurrenceRepeatType === 1}>
						<Row className="margin-bottom-15">
							<Col sm={3} className="text-right text-left-xs">Recurring:</Col>
							<Col sm={1} />
							<Col sm={8}>
								Daily until&nbsp;
								{this.formatRecurrenceEndDate(invoiceEstimate.JobEventRecurrenceEndsOn)}
							</Col>
						</Row>
					</When>
				</Choose>
				<Row className="margin-bottom-15">
					<Col sm={3} className="text-right text-left-xs">Job Location:</Col>
					<Col sm={1} />
					<Col sm={8}>{ formattedAddress }</Col>
				</Row>
				<Row className="margin-bottom-15">
					<Col sm={3} className="text-right text-left-xs">Agency:</Col>
					<Col sm={1} />
					<Col sm={8}>{ invoiceEstimate.AgencyName }</Col>
				</Row>
				<Row className="margin-bottom-15">
					<Col sm={3} className="text-right text-left-xs">Estimate Details:</Col>
					<Col sm={1} />
					<Col sm={8}>
						<Button
							bsStyle="link"
							onClick={getInvoiceEstimatePDF}
							className="padding-0"
						>
							View PDF
						</Button>
					</Col>
				</Row>
			</Fragment>
		);
	}
}

InvoiceInfo.propTypes = {
	invoiceEstimate       : PropTypes.object,
	timeZoneId            : PropTypes.string.isRequired,
	getInvoiceEstimatePDF : PropTypes.func.isRequired,
};

InvoiceInfo.defaultProps = {
	invoiceEstimate : {},
};

export default InvoiceInfo;
